"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNumberOfLikelyIgnoredCalls = void 0;
const get_number_of_groups_in_list_1 = require("../../../../utilities/data-structure-utils.ts/get-number-of-groups-in-list");
const was_likely_part_of_an_ignored_call_1 = require("./was-likely-part-of-an-ignored-call");
function getNumberOfLikelyIgnoredCalls(items) {
    return (0, get_number_of_groups_in_list_1.getNumberOfGroupsInList)(items, was_likely_part_of_an_ignored_call_1.wasLikelyPartOfAnIgnoredCall);
}
exports.getNumberOfLikelyIgnoredCalls = getNumberOfLikelyIgnoredCalls;
